import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import DefaultLayout from "../layouts/DefaultLayout";

Vue.use(VueRouter);

let meta = {
    layout: DefaultLayout,
};

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home,
        meta: meta
    },
    {
        path: '*',
        redirect: {name: '404', params: {resource: 'page'}}
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior () {
        return { x: 0, y: 0 }
    }
});

export default router
